import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';

/**
 * Site-wide header with responsive mobile menu.
 * Nav items are passed in so Home and Herancas can use different anchors.
 */
export const Header = ({ navItems, logoHref = '/' }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const closeMenu = () => setMobileMenuOpen(false);

  return (
    <header className="valuare-header" data-testid="site-header">
      <div className="valuare-header-content">
        <a
          href={logoHref}
          className="valuare-logo-area"
          style={{ textDecoration: 'none', color: 'inherit' }}
          data-testid="header-logo-link"
        >
          <div>
            <div className="valuare-logo-text">VALUARE JR®</div>
            <span className="valuare-logo-sub">Avaliações Imobiliárias</span>
          </div>
        </a>
        <button
          className="valuare-mobile-menu-btn"
          onClick={() => setMobileMenuOpen((v) => !v)}
          aria-label="Menu"
          data-testid="header-mobile-menu-btn"
        >
          {mobileMenuOpen ? <X /> : <Menu />}
        </button>
        <nav className={`valuare-nav ${mobileMenuOpen ? 'active' : ''}`} data-testid="header-nav">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={closeMenu}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};
